module.exports = __webpack_public_path__ + "static/img/chevron-down.aed60c51.svg";